import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import DisplayContainer from "../../../../components/displayContainer/DisplayContainer";
import ImageUploader from "../../../../components/inputs/imageUploader/ImageUploader";
import Loader from "../../../../components/loader/Loader";
import TextWrapper from "../../../../components/textWrapper/TextWrapper";
import { fetchMultiPurposeImages } from "../../../../features/images/multiPurposeImages/multiPurposeImagesSlice";
import styles from "./multiPurposeImages.module.css";
import MultiPurposeOneImage from "./multiPurposeOneImage/MultiPurposeOneImage";

const MultiPurposeImages = () => {
  const dispatch = useDispatch();

  const {
    fetchStatus,
    deleteStatus,
    list: multiPurposeImages,
    uploadStatus,
  } = useSelector((state) => state.multiPurposeImages);

  useEffect(() => {
    if (fetchStatus === "idle") {
      dispatch(fetchMultiPurposeImages());
    }
  }, [dispatch, fetchStatus]);

  if (
    fetchStatus === "loading" ||
    deleteStatus === "loading" ||
    uploadStatus === "loading"
  ) {
    return (
      <div className={styles.loaderContainer}>
        <Loader />
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.headerRow}>
        <TextWrapper textStyle="textTitle">صور متعددة الاستخدام</TextWrapper>
        <div className={styles.imageUploaderWrapper}>
          <ImageUploader tag={"multi-purpose"} label="رفع صورة جديدة" />
        </div>
      </div>
      <div className={styles.allImagesWrapper}>
        <DisplayContainer className={styles.imagesDisplay}>
          {multiPurposeImages.map((item) => {
            return (
              <MultiPurposeOneImage
                key={item._id}
                path={item.path}
                name={item.name}
                id={item._id}
              />
            );
          })}
        </DisplayContainer>
      </div>
    </div>
  );
};

export default MultiPurposeImages;
